import dayjs from 'dayjs'

import { dateInTimezone, getDefaultTimezone } from './timezone'

// FullCalendar supplies actual instants; applying the computer offset again
// shifts the range and can also use the wrong season's offset.
export function calendarRangeFromDates(
  start: Date,
  exclusiveEnd: Date,
  zone = getDefaultTimezone()
) {
  return {
    start: dateInTimezone(start, zone),
    exclusiveEnd: dateInTimezone(exclusiveEnd, zone),
    end: dateInTimezone(dayjs(exclusiveEnd).subtract(1, 'second'), zone)
  }
}

// A date-only navigation target is a wall date, not midnight in the computer zone.
export function calendarNavigationDate(
  value: Date | string,
  zone = getDefaultTimezone()
) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? dayjs.tz(value, zone)
    : dateInTimezone(value, zone)
}

export function allDayReminderTime(
  startTime: string,
  daysBefore = 0,
  zone = getDefaultTimezone()
) {
  const calendarDate = dayjs
    .unix(Number(startTime))
    .utc()
    .subtract(daysBefore, 'day')
    .format('YYYY-MM-DD')
  return dayjs.tz(`${calendarDate} 09:00`, zone)
}
